<template>
  <div
    v-if="initialized"
    class="flex h-full w-full"
  >
    <SidebarEmployee v-if="!mq.isMobile" />
    <div class="flex h-full min-w-0 flex-1 flex-col">
      <InvoiceOverdueBanner
        v-if="billing_current_client && billing_current_client.attributes.invoice_overdue"
        :billing="billing_current_client"
      />
      <NavbarTopEmployee v-if="mq.isMobile" />

      <TheNavbarDesktopEmployeeHorizontal v-if="!mq.isMobile" />
      <div v-if="current_project && current_project.attributes.skip_customer">
        <div
          v-if="!$flipper.enabled($FT.TEMPLATE_PROJECTS)"
          class="has-background-primary-light has-text-color-primary flex items-center justify-center p-2 font-medium"
        >
          <span>
            <ButtonUpsell feature="project_templates">
              {{ $t('upsell.project_templates.cta2') }}
            </ButtonUpsell>
          </span>
        </div>
      </div>
      <div v-else-if="current_project && !current_project.attributes.activated">
        <div
          class="has-background-primary-light has-text-color-primary flex items-center justify-center gap-2 p-2 font-medium"
        >
          <FontAwesomeIcon icon="toggle-off" />
          {{ $t('project.labels.projectIsDeactivated') }}
        </div>
      </div>
      <main
        class="h-full w-full overflow-y-auto"
        style="content-visibility: auto; contain-intrinsic-size: auto 700px"
      >
        <div
          class="mx-auto max-w-[1800px] px-5 py-3"
          :class="{ 'h-full': $route.params.ticket_id }"
        >
          <router-view />
        </div>
      </main>
    </div>
    <TheNotificationsSidebar v-show="show_notification_sidebar" />
    <TheAiAssistant v-if="$flipper.enabled($FT.AI_ASSISTANT)" />
  </div>
  <TheLoadingWheel v-if="!initialized" />
</template>

<script>
import TheNavbarDesktopEmployeeHorizontal from '@/app/_employees/components/navbar/TheNavbarDesktopEmployeeHorizontal.vue';
import SidebarEmployee from '@/app/_employees/components/navbar/TheSidebarEmployee.vue';
import NavbarTopEmployee from '@/app/_employees/components/navbar/TheNavbarTopEmployee.vue';
import InvoiceOverdueBanner from '@/app/_employees/components/InvoiceOverdueBanner.vue';
import profile_mixin from '@/app/util/profile_mixin';
import { mapGetters } from 'vuex';
import TheNotificationsSidebar from '@/app/shared_components/navbar/notifications/TheNotificationsSidebar.vue';
import SIDEBAR_NOTIFICATIONS from '@/app/data/sidebar_constants';
import { useMqService } from '@/plugins/mq';
import TheAiAssistant from '@/app/_employees/components/ai/TheAiAssistant.vue';

export default {
  name: 'Employee',
  components: {
    TheNotificationsSidebar,
    SidebarEmployee,
    NavbarTopEmployee,
    TheNavbarDesktopEmployeeHorizontal,
    InvoiceOverdueBanner,
    TheAiAssistant,
  },
  mixins: [profile_mixin],
  setup() {
    const mq = useMqService();
    return { mq };
  },
  computed: {
    ...mapGetters(['current_client', 'current_project', 'sidebar_type']),
    show_notification_sidebar() {
      return this.sidebar_type === SIDEBAR_NOTIFICATIONS;
    },
  },

  async created() {
    await this.initProfile();
  },
};
</script>
